import { omitKeys } from './omitKeys';

export const omitTypename = (obj) => omitKeys(obj, ['__typename']);
